
import { Component, Vue, Prop } from 'vue-property-decorator';
import { SharedDeviceInfo } from '@/types/device-info';

@Component({
    components: {},
})
export default class DeviceSharesRendrer extends Vue {
    @Prop({ required: true })
    list!: SharedDeviceInfo;
}
